module.exports = __webpack_public_path__ + "img/4.5bda3739.png";